import axios from "axios";
import { PROXY_RATES } from "../envVariables";

// Direct Cloud Run endpoint, or the same-origin Netlify proxy when REACT_APP_PROXY_RATES=YES
// (P1: hides the upstream + adds a rate-limiting seam). Same request/response shape either way.
const DIRECT_RATE_URL = "https://rate-api-462238530065.us-central1.run.app/rate-search";
const PROXY_RATE_URL = "/api/rate-search";

export const makeGCPRequest = async (payload) => {
  //   console.log("--making GCP request--", JSON.stringify(payload, null, 2));

 const url = PROXY_RATES === "YES" ? PROXY_RATE_URL : DIRECT_RATE_URL;

  try {
    const response = await axios.post(url, payload, {
      headers: { "Content-Type": "application/json" },
    });
    // console.log("----response------",response)

    const { status, data } = response;
    console.log("GCP Response status:", status);

    if (data?.ok) {
      if (data.error) {
        // 🚨 Throw an error if API explicitly reports one
        throw new Error(
          `GCP request error: ${typeof data.error === "string" ? data.error : JSON.stringify(data.error)}`
        );
      }

      console.log("✅ GCP Request accepted");
    //   console.log("Response results:", data.results);
      return data.results || [];
    }

    console.warn("⚠️ GCP Request not accepted:", data);
    return [];
  } catch (error) {
    if (error.response) {
        console.log("error.response: ",error.response)
      const { status, data } = error.response;
      const tokenExpiredDetail = Array.isArray(data?.details)
        ? data.details.find((detail) =>
            typeof detail?.message === 'string' &&
            (detail.message.toLowerCase().includes('token is expired') ||
              detail.message.toLowerCase().includes('bearer token'))
          )
        : null;

      if (tokenExpiredDetail) {
        const message = 'Token Expire, Sign-out and Sign-in again';
        console.error('GCP token error:', status, message);
        throw new Error(message);
      }

      if (
        typeof data?.error === 'string' &&
        data.error.toLowerCase() === 'validation_error' &&
        Array.isArray(data?.details)
      ) {
        const bearerDetail = data.details.find(
          (detail) =>
            typeof detail?.message === 'string' &&
            detail.message.toLowerCase().includes('bearer token')
        );
        if (bearerDetail) {
          const message = 'Token Expire, Sign-out and Sign-in again';
          console.error('GCP token error:', status, message);
          throw new Error(message);
        }
      }

      console.error('GCP error response:', status, data);
      throw new Error(`GCP HTTP error ${status}: ${JSON.stringify(data)}`);
    } else if (error.request) {
      console.error("No response from GCP:", error.request);
      throw new Error("No response from GCP");
    } else {
      console.error("Error creating request:", error.message);
      throw error; // re-throw so caller can handle
    }
  }
};